import { abrePDF } from "../../../utils/pdf";
import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import Baja from "../../Baja";
import BajaMultiple from "../../BajaMultiple";
import StatusMultiple from "../../StatusMultiple";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import qrcode from "qrcode-js";
import moment from 'moment';
import { v4 as uuidv4 } from "uuid";
import AutorizadoMultiple from "../../AutorizadoMultiple";

function ListadoAbonosProveedores() {
  const { user } = useContext(AuthContext);
  const URL_ABONOS_PROVEEDORES = process.env.REACT_APP_URL_ABONOS_PROVEEDORES;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;

  let hoy = new Date()
  let inicio = new Date()
  inicio.setDate(inicio.getDate()-30);
 
  let endDate   = moment(hoy).format("YYYY-MM-DD"); 
  let startDate   = moment(inicio).format("YYYY-MM-DD");


  const [proveedores, setProveedores] = useState([]);
  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);
  // C16: filtro por importe — "todos" / "conImporte" (>0) / "cero" (=0)
  const [selectedImporte, setSelectedImporte] = useState("conImporte");

  const [idAbonoEdit, setIdAbonoEdit] = useState("");
  const [numeroEdit, setNumeroEdit] = useState("");
  const [fechaEdit, setFechaEdit] = useState("");
  const [idProveedorEdit, setIdProveedorEdit] = useState("");
  const [importeEdit, setImporteEdit] = useState("");
  const [tipoCambioEdit, setTipoCambioEdit] = useState("");
  const [importeEditViejo, setImporteEditViejo] = useState("");
  const [proveedorEdit, setProveedorEdit] = useState("");
  const [idBancoEdit, setIdBancoEdit] = useState("");
  const [notaEdit, setNotaEdit] = useState("");
  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);
  const [validaBoton, setValidaBoton] = useState(true);
  const [text, setText] = useState(false);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);

  // Comprobante: ver/subir/descargar
  const [modalComprobante, setModalComprobante] = useState(false);
  const [comprobanteAbono, setComprobanteAbono] = useState(null);
  const [archivoFile, setArchivoFile] = useState(null);

  function abrirComprobante(abono) {
    setComprobanteAbono(abono);
    setArchivoFile(null);
    setModalComprobante(true);
  }

  async function subirComprobante() {
    if (!archivoFile || !comprobanteAbono) return;
    try {
      const form = new FormData();
      form.append("file", archivoFile);
      const up = await axios.post(process.env.REACT_APP_URL_UPMEDIA, form, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      });
      const url = up.data?.secure_url || up.data?.url;
      const tipo = archivoFile.type?.includes("pdf") ? "PDF" : "IMG";
      await axios.patch(
        `${URL_ABONOS_PROVEEDORES}/comprobante/${comprobanteAbono._id}`,
        { urlComprobante: url, tipoComprobante: tipo },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      );
      setComments((prev) =>
        prev.map((c) =>
          c._id === comprobanteAbono._id
            ? { ...c, urlComprobante: url, tipoComprobante: tipo }
            : c
        )
      );
      setComprobanteAbono((prev) => prev ? { ...prev, urlComprobante: url, tipoComprobante: tipo } : prev);
      setArchivoFile(null);
      Swal.fire({ icon: "success", title: "Comprobante subido" });
    } catch (e) {
      Swal.fire({ icon: "error", title: "Error al subir" });
    }
  }

  async function eliminarComprobante() {
    if (!comprobanteAbono?._id) return;
    const ok = await Swal.fire({
      title: "Eliminar comprobante",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    });
    if (!ok.isConfirmed) return;
    try {
      await axios.patch(
        `${URL_ABONOS_PROVEEDORES}/comprobante/${comprobanteAbono._id}`,
        { urlComprobante: "", tipoComprobante: "" },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      );
      setComments((prev) =>
        prev.map((c) =>
          c._id === comprobanteAbono._id
            ? { ...c, urlComprobante: "", tipoComprobante: "" }
            : c
        )
      );
      setComprobanteAbono((prev) => prev ? { ...prev, urlComprobante: "", tipoComprobante: "" } : prev);
      Swal.fire({ icon: "success", title: "Eliminado" });
    } catch (e) {
      Swal.fire({ icon: "error", title: "Error al eliminar" });
    }
  }
  const [mailTo, setMailTo] = useState("");
  
  const [totalTotalPesos, setTotalTotalPesos] = useState(0);
  const [totalTotalDolares, setTotalTotalDolares] = useState(0);
  const [totalTotalDolaresPesos, setTotalTotalDolaresPesos] = useState(0);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useMemo(()=>{
    axios
      .get(`${URL_ABONOS_PROVEEDORES}Fechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allAbonos = response.data;
        // Array para pagination
        let arrayTabla = allAbonos
          .sort((a, b) => (a.idAbono < b.idAbono ? 1 : -1))
          .map((a) => {
            if (!a.proveedores?.[0] || a.proveedores[0].tipo !== "China") return null;
            const banco = a.bancos?.[0];
            return {
              _id: a._id,
              numero: a.idAbonoProveedor,
              fecha: a.fecha,
              proveedores: a.proveedores[0].nombre_comercial,
              idProveedores: a.proveedores[0]._id,
              importe: a.importe,
              tipoCambio: a.tipoCambio,
              bancos: banco ? `${banco.banco || ""} ${banco.cuenta || ""}`.trim() : "NA",
              idBancos: banco?._id || "",
              notaCxP: a.notasCxP ? `#${a.notasCxP.idNotasCxP || ""}` : "",
              anticipoRel: a.anticipos ? `#${a.anticipos.idAnticipo || ""}` : "",
              urlComprobante: a.urlComprobante || "",
              tipoComprobante: a.tipoComprobante || "",
            }
          })
          .filter(function (el) {
            return el != null;
          });

        let data = Object.values(arrayTabla);

        setComments(data);
        //
      })
      .catch((err) => {
        console.log(err);
      });

    axios
    .get(`${URL_PROVEEDORES}Tipo/China`, { 
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allProveedores = response.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });

  }, [ selectedFechaInicio, selectedFechaFin]);


  function PDFTabla() {
    let TotalImporte= 0
    const data = comments
    .filter(
      (comment) =>
        comment.proveedores.toLowerCase().includes(search.toLowerCase()) ||
        comment.importe.toString().includes(search) ||
        comment.numero.toString().includes(search) 
    )
    .sort((a, b) => (a.idAbono > b.idAbono ? 1 : -1))
    .map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedProveedor == 0 || selectedProveedor == a.idProveedores)
      ) {
        TotalImporte = TotalImporte + a.importe
        return [
          a.numero,
          a.fecha,
          a.proveedores,
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.importe),
        ];
      }
    });

    const dataPDF = Object.values(data);

    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });


    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 10, 35, 18);
    doc.text(`Listado Abonos`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Numero",
          "Fecha",
          "Proveedor",
          "Importe",
        ],
      ],
      body: dataPDFLimpia,
 headStyles: {
            fillColor: ["#B02307"],
            lineWidth: 0
          },
          footStyles: {
            fillColor: ["#B02307"],
          },
          theme:"grid",
      startY: 45,
      foot: [
        [
          "",
          "",
          "Total",
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(TotalImporte)
        ]
      ]
    });
    abrePDF(doc, `Abonos.pdf`);
  }

  function excel() {
    const dataExcel = comments
    .filter(
      (comment) =>
        comment.proveedores.toLowerCase().includes(search.toLowerCase()) ||
        comment.importe.toString().includes(search) ||
        comment.numero.toString().includes(search) 
    )
    .sort((a, b) => (a.idAbono > b.idAbono ? 1 : -1))
    .map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedProveedor == 0 || selectedProveedor == a.idProveedores)
      ) {
        return {
          Numero: a.numero,
          Fecha: a.fecha,
          Proveedor: a.proveedores,
          Importe: a.importe,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoAbonos";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoAbonos",
        sheetFilter: [
          "Numero",
          "Fecha",
          "Proveedor",
          "Importe",
          ],
        sheetHeader: [
          "Numero",
          "Fecha",
          "Proveedor",
          "Importe",
          ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    let TotalImporte= 0
    const data = comments
    .filter(
      (comment) =>
        comment.proveedores.toLowerCase().includes(search.toLowerCase()) ||
        comment.importe.toString().includes(search) ||
        comment.numero.toString().includes(search) 
    )
    .sort((a, b) => (a.idAbono > b.idAbono ? 1 : -1))
    .map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedProveedor == 0 || selectedProveedor == a.idProveedores)
      ) {
        TotalImporte = TotalImporte + a.importe
        return [
          a.numero,
          a.fecha,
          a.proveedores,
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.importe),
        ];
      }
    });

    const dataPDF = Object.values(data);

    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });


    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 10, 35, 18);
    doc.text(`Listado Abonos`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Numero",
          "Fecha",
          "Proveedor",
          "Importe",
        ],
      ],
      body: dataPDFLimpia,
 headStyles: {
            fillColor: ["#B02307"],
            lineWidth: 0
          },
          footStyles: {
            fillColor: ["#B02307"],
          },
          theme:"grid",
      startY: 45,
      foot: [
        [
          "",
          "",
          "Total",
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(TotalImporte)
        ]
      ]
    });
    
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Abonos",
          email: mailTo,
          fileName: "ListadoAbonos.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Abonos.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }




  const headers = [
    { name: "Numero", field: "numero", sortable: true },
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "Proveedor", field: "proveedores", sortable: true },
    { name: "Importe", field: "importe", sortable: true },
    { name: "Tipo de Cambio", field: "tipoCambio", sortable: true },
    { name: "Total Pesos", field: "totalPesos", sortable: false },
    { name: "Editar", field: "editar", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.proveedores.toLowerCase().includes(search.toLowerCase()) ||
          comment.importe.toString().includes(search) ||
          comment.tipoCambio.toString().includes(search) ||
          comment.numero.toString().includes(search) 
      );
    }
    if (selectedProveedor) {
      computedComments = computedComments.filter((e) =>
        e.idProveedores.includes(selectedProveedor)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }

    // C16: filtro por importe
    if (selectedImporte === "conImporte") {
      computedComments = computedComments.filter((e) => parseFloat(e.importe || 0) > 0);
    } else if (selectedImporte === "cero") {
      computedComments = computedComments.filter((e) => parseFloat(e.importe || 0) === 0);
    }

    let pesos = computedComments.filter((e) => e.tipoCambio == 1);

    let impP = pesos.map((c) => parseFloat(c.importe));
    let TimpP = impP.reduce((t, cajas, index) => t + cajas, 0);
    setTotalTotalPesos(TimpP);

    let dls = computedComments.filter((e) => e.tipoCambio > 1);

    let impD = dls.map((c) => parseFloat(c.importe));
    let TimpD = impD.reduce((t, cajas, index) => t + cajas, 0);
    setTotalTotalDolares(TimpD);

    let impDP = computedComments.map((c) => parseFloat(c.importe) * parseFloat(c.tipoCambio));
    let TimpDP = impDP.reduce((t, cajas, index) => t + cajas, 0);
    setTotalTotalDolaresPesos(TimpDP);

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "importe" &&
      sorting.field != "tipoCambio" &&
      sorting.field != "numero"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "importe" ||
        sorting.field == "tipoCambio" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "importe" ||
        sorting.field == "tipoCambio" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedProveedor,
    selectedFechaInicio,
    selectedFechaFin,
    selectedImporte,
  ]);

  function cancelarAbono(_id, numero, proveedor) {
    Swal.fire({
      title: `¿Cancelar abono #${numero}?`,
      text: `Se revertirán los saldos del proveedor ${proveedor}, del banco (si aplica) y de la nota o anticipo ligado.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Sí, cancelar",
      cancelButtonText: "No",
    }).then((result) => {
      if (!result.isConfirmed) return;
      axios
        .patch(
          `${URL_ABONOS_PROVEEDORES}/cancel/${_id}`,
          {},
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          axios.post(
            URL_LOGS,
            {
              tipo: "Cancelar Abono Proveedor",
              detalle: `Abono #${numero} ${proveedor}`,
              user: user.id,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );
          Swal.fire("Cancelado", "El abono se canceló correctamente", "success");
          setTimeout(() => window.location.reload(), 800);
        })
        .catch((error) => {
          const msg =
            error?.response?.data?.message ||
            error?.message ||
            "Error al cancelar";
          console.error("[cancelarAbono]", msg, error?.response?.data);
          Swal.fire({ icon: "error", title: "No se pudo cancelar", text: msg });
        });
    });
  }

  function EditAbono(
    _id,
    numero,
    fecha,
    idProveedores,
    importe,
    tipoCambio,
    proveedor,
    idNota,
    idBanco
  ) {
    setIdAbonoEdit(_id);
    setNumeroEdit(numero);
    setFechaEdit(fecha);
    setIdProveedorEdit(idProveedores);
    setImporteEdit(importe);
    setTipoCambioEdit(tipoCambio);
    setImporteEditViejo(importe);
    setProveedorEdit(proveedor);
    setNotaEdit(idNota);
    setIdBancoEdit(idBanco)
    toggleEdit();
  }
  
  const EditAbonoSave = (event) => {
    event.preventDefault();
    Swal.fire({
      title: "Estas seguro?",
      text: "Se registrará el abono",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Enviar!",
    }).then((result) => {
      if (result.isConfirmed) {
        // Sólo incluir campos con valor: bancos vacío rompe Joi (
        // "\"bancos\" is not allowed to be empty").
        const editPayload = {
          importe: parseFloat(importeEdit) - parseFloat(importeEditViejo),
          tipoCambio: tipoCambioEdit,
        };
        if (fechaEdit) editPayload.fecha = fechaEdit;
        if (idProveedorEdit) editPayload.proveedores = idProveedorEdit;
        if (idBancoEdit) editPayload.bancos = idBancoEdit;
        axios
          .patch(
            `${URL_ABONOS_PROVEEDORES}/${idAbonoEdit}`,
            editPayload,
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            axios.post(
              URL_LOGS,
              {
                tipo: "Editar Abono",
                detalle: `${proveedorEdit}`,
                user: user.id,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            );
            Swal.fire("Good job!", "Creado con exito", "success");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          })
          .catch((error) => {
            const msg = error?.response?.data?.validation?.body?.message
              || error?.response?.data?.message
              || (typeof error?.response?.data === "string" ? error.response.data : null)
              || error?.message
              || "Error inesperado";
            console.error("[EditAbono] error", msg, error?.response?.data, error);
            Swal.fire({
              icon: "error",
              title: "No se pudo editar",
              text: msg,
            });
          });
      }
    });
  };

 

  return (
    <>
      <Header />
      <br />
      <br />
      {user.pagoProveedores ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {user.pagoProveedores ? (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/AbonosProveedoresCreate"
                >
                  Nuevo Abono
                </Button>
              ) : (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  disabled
                >
                  Nuevo Abono
                </Button>
              )}
              <Button
                size="sm"
                href="/MenuCXP"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Abonos</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Reporte de Abonos</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Importe</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedImporte}
                onChange={(e) => {
                  setSelectedImporte(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="conImporte">Con importe</option>
                <option value="todos">Todos</option>
                <option value="cero">Solo en 0</option>
              </Input>
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tr>
              <td></td>
              <td></td>
              <td style={{ paddingTop: "0px" }}>
              <Input
                bsSize="sm"
                type="select"
                value={selectedProveedor}
                onChange={(e) => {
                  setSelectedProveedor(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                {proveedores
                  .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
              </td>

              <td style={{ paddingTop: "0px" }}>
              
              </td>
            </tr>
            <tbody>
              {commentsData.map((a) => {
                  return (
                    <tr>
                      <td>{a.numero}</td>
                      <td style={{ minWidth: 100 }}>{a.fecha}</td>
                      <td>{a.proveedores}</td>
                      <td align="center">{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.importe)}</td>
                      <td align="center">{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.tipoCambio)}</td>
                      <td align="center">{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.tipoCambio * a.importe)}</td>
                      <td style={{ minWidth: 120 }}>

                            <Button
                              size="sm"
                              className="btn"
                              color="info"
                              onClick={(e) =>
                                EditAbono(
                                  a._id,
                                  a.numero,
                                  a.fecha,
                                  a.idProveedores,
                                  a.importe,
                                  a.tipoCambio,
                                  a.proveedores,
                                  a.idNota,
                                  a.idBancos
                                )
                              }
                            >
                              <i class="far fa-edit"></i>
                            </Button>
                            {" "}
                            <Button
                              size="sm"
                              color={a.urlComprobante ? "success" : "secondary"}
                              title={a.urlComprobante ? "Ver comprobante" : "Subir comprobante"}
                              onClick={() => abrirComprobante(a)}
                            >
                              <i className="fas fa-paperclip"></i>
                            </Button>
                            {" "}
                            <Button
                              size="sm"
                              color="danger"
                              title="Cancelar abono"
                              onClick={() => cancelarAbono(a._id, a.numero, a.proveedores)}
                            >
                              <i className="fas fa-ban"></i>
                            </Button>
                      </td>
                    
                    </tr>
                  );
              })}
              <tr>
                <td></td>
                <td></td>
                <td colSpan="3" className="negrita" align="right">TOTAL PAGOS EN PESOS</td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalTotalPesos)}
                </td>
                <td></td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td colSpan="3" className="negrita" align="right">TOTAL PAGOS EN DOLARES</td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalTotalDolares)}
                </td>
                <td></td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td colSpan="3" className="negrita" align="right">
    TOTAL PESOS
  </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalTotalDolaresPesos)}
                </td>
                <td></td>
              </tr>
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />
      <Modal size="sm" isOpen={modalEdit} toggle={toggleEdit}>
            <ModalHeader toggle={toggleEdit}>
              <h4>Editar Abono {numeroEdit} {proveedorEdit}</h4>
            </ModalHeader>
            <ModalBody>
              <Form onSubmit={EditAbonoSave}>
                <Row>
                  <Col md={6}>
                    <Label>Fecha</Label>
                    <Input
                      type="date"
                      value={fechaEdit}
                      required
                      onChange={(e) => {
                        setFechaEdit(e.target.value);
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                <Col md={6}>
                    <Label>TipoCambio</Label>
                    <Input
                      className="col-sm-12"
                      type="number"
                      placeholder="TipoCambio"
                      value={tipoCambioEdit}
                      required
                      onChange={(e) => {
                        setTipoCambioEdit(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={6}>
                    <Label>Importe</Label>
                    <Input
                      className="col-sm-12"
                      type="number"
                      placeholder="Importe"
                      value={importeEdit}
                      required
                      onChange={(e) => {
                        setImporteEdit(e.target.value);
                      }}
                    />
                  </Col>
                </Row>

                <br />
                <Row>
                    <Button type="submit" className="btn btn-success">
                      Guardar
                    </Button>

                  <div>
                    <SweetAlert
                      show={text}
                      title="Creado con Exito"
                      onConfirm={() => {
                        setText(false);
                      }}
                    />
                  </div>
                </Row>
              </Form>
            </ModalBody>
          </Modal>

      <Modal
        size="xl"
        isOpen={modalComprobante}
        toggle={() => setModalComprobante(false)}
      >
        <ModalHeader toggle={() => setModalComprobante(false)}>
          Comprobante {comprobanteAbono ? `Abono #${comprobanteAbono.numero}` : ""}
        </ModalHeader>
        <ModalBody style={{ textAlign: "center" }}>
          {comprobanteAbono?.urlComprobante ? (
            <>
              {comprobanteAbono.tipoComprobante === "PDF" ? (
                <iframe
                  title="Comprobante"
                  src={comprobanteAbono.urlComprobante}
                  style={{ width: "100%", height: "70vh", border: "1px solid #ccc" }}
                />
              ) : (
                <img
                  src={comprobanteAbono.urlComprobante}
                  alt="Comprobante"
                  style={{ maxWidth: "100%", maxHeight: "70vh", border: "1px solid #ccc" }}
                />
              )}
              <div style={{ marginTop: 12, display: "flex", gap: 10, justifyContent: "center", flexWrap: "wrap" }}>
                <a
                  href={comprobanteAbono.urlComprobante}
                  target="_blank"
                  rel="noopener noreferrer"
                  download={`Comprobante-Abono-${comprobanteAbono.numero}`}
                  className="btn btn-primary"
                >
                  <i className="fas fa-download" /> Descargar
                </a>
                <label className="btn btn-warning" style={{ marginBottom: 0 }}>
                  <i className="fas fa-sync" /> Reemplazar
                  <input
                    type="file"
                    accept="application/pdf,image/*"
                    style={{ display: "none" }}
                    onChange={(e) => setArchivoFile(e.target.files?.[0] || null)}
                  />
                </label>
                {archivoFile ? (
                  <Button color="success" onClick={subirComprobante}>
                    <i className="fas fa-upload" /> Subir {archivoFile.name}
                  </Button>
                ) : null}
                <Button color="danger" onClick={eliminarComprobante}>
                  <i className="fas fa-trash" /> Eliminar
                </Button>
              </div>
            </>
          ) : (
            <>
              <p style={{ color: "#888" }}>No hay comprobante. Sube uno.</p>
              <input
                type="file"
                accept="application/pdf,image/*"
                onChange={(e) => setArchivoFile(e.target.files?.[0] || null)}
              />
              <div style={{ marginTop: 12 }}>
                <Button color="success" disabled={!archivoFile} onClick={subirComprobante}>
                  <i className="fas fa-upload" /> Subir
                </Button>
              </div>
            </>
          )}
        </ModalBody>
      </Modal>

      {loader}
    </>
  );
}

export default ListadoAbonosProveedores;
